import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import styles from '../ElectionPartyComponent/Styles/ElectionDeleteConfirmationModal.module.css';


const ElectionDeleteConfirmationModal = ({ isOpen, onClose, onConfirm, agentName }) => {
  useEffect(() => {
    if (isOpen) {
      Swal.fire({
        title: 'Confirm Deletion',
        text: `Are you sure you want to delete ${agentName || 'this item'}? This action cannot be undone.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        customClass: {
          popup: styles.customSwalPopup,
          container: styles.customSwalContainer,
        },
        backdrop: true,
      }).then((result) => {
        if (result.isConfirmed) {
          onConfirm(); // Trigger the delete action
          Swal.fire({
            title: 'Deleted!',
            text: `${agentName || 'Item'} has been successfully deleted.`,
            icon: 'success',
            customClass: {
              popup: styles.customSwalPopup,
              container: styles.customSwalContainer,
            },
            backdrop: true,
            timer: 2000, // Auto-close after 2 seconds
            timerProgressBar: true, // Show progress bar for auto-close
            showConfirmButton: false, // No confirm button needed for success
          }).then(() => {
            onClose(); // Close the modal after the success popup
          });
        } else {
          onClose(); // Close if user cancels
        }
      });
    }
  }, [isOpen, onConfirm, onClose, agentName]);

  return null;
};

export default ElectionDeleteConfirmationModal;